/*
 * CustomRadio converts a regular radio button into a fancy radio button
 *      Xoom "Module" Format.
 *      Documentation: http://confluence/display/Eng/JavaScript+Module+Framework
 */
/* jslint es6 */
import $ from 'zepto';
import { onDocumentReady } from '../../main';
import {
  CUSTOM_RADIO_CONTAINER,
} from '../../utils/legacy/constants';

import {
  CONTAINER,
} from '../../utils/legacy/templateConstants';

import {
  $$$,
  registerDomObjects,
} from '../../utils/legacy';

export function initCustomRadio() {
  const customRadios = {};

  function CustomRadio(id) {
    const $input = $$$(id);
    const inputElement = $input[0];
    const $label = $(`label[for=${id}]`);

    function init() {
      // get input element wrap it with custom-radio-container
      // move the label into the custom-radio-container

      if (!inputElement.initialized) { // prevent from executing multiple times
        inputElement.initialized = 1;

        $input.wrap(CONTAINER.replaceTokens(CUSTOM_RADIO_CONTAINER)).after($label);
        $input.addClass('custom-radio');

        $label
          .wrapInner('<span class="custom-radio-label-contents"/>')
          .prepend('<span class="custom-radio-button"></span>')
          .bind('click', () => {
            $input.trigger('click, change');
          });
      }
    }
    init();
  }

  function addCustomRadio(id) {
    let uiElementScope;
    const radio = new CustomRadio(id);

    if ($$$(id).isChildOf('.xoom-dialog')) {
      uiElementScope = 'xoom-dialog';
    }

    // TODO: set getting-started.js to make all sections have a class of ajax-content
    // (if the content was retrieved via ajax)
    if ($$$(id).isChildOf('.ajax-content')) {
      uiElementScope = 'ajax-content';
    }

    registerDomObjects(`customRadio${id}`, radio, uiElementScope);
    customRadios[id] = radio;
    return radio;
  }

  function initializeWidget(contextSelector, callback) {
    const $customRadios = $('input.custom-radio', contextSelector || $('body'));
    if ($customRadios.length) {
      $customRadios.each(function customRadioSelected() {
        addCustomRadio(this.id);
      });
    }

    if (callback) {
      callback();
    }
  }

  return {
    initializeWidget,
    add: addCustomRadio,
  };
}

// TODO: Add context implementation
onDocumentReady('CustomRadio', () => {
  initCustomRadio().initializeWidget();
});

export default {
  initCustomRadio,
};

registerDomObjects('CustomRadio', initCustomRadio);
